import { Award } from "lucide-react";

const TIERS = {
    gold:   { label: "Gold",   ring: "from-yellow-100 to-amber-200", bg: "bg-amber-100 text-amber-800 border-amber-300",  icon: "text-amber-600" },
    silver: { label: "Silver", ring: "from-slate-100 to-slate-200",  bg: "bg-slate-100 text-slate-700 border-slate-300",  icon: "text-slate-500" },
    bronze: { label: "Bronze", ring: "from-orange-100 to-amber-100", bg: "bg-orange-100 text-orange-800 border-orange-300", icon: "text-orange-600" },
};

/**
 * MilestoneBadge — bronze/silver/gold badge for KRA milestones and training.
 * `tier` in {"gold","silver","bronze","none"}. Renders nothing for "none".
 */
export function MilestoneBadge({ tier = "none", label, size = "md", testid }) {
    if (!tier || tier === "none") return null;
    const t = TIERS[tier] || TIERS.bronze;
    const cls = size === "sm" ? "text-[10px] px-2 py-0.5" : "text-xs px-2.5 py-1";
    return (
        <span className={`inline-flex items-center gap-1 rounded-full border font-semibold ${cls} ${t.bg}`} data-testid={testid || `badge-${tier}`}>
            <Award className={`${size === "sm" ? "w-3 h-3" : "w-3.5 h-3.5"} ${t.icon}`} strokeWidth={2.5} />
            {label || t.label}
        </span>
    );
}

export default MilestoneBadge;
